document.addEventListener('DOMContentLoaded', function() {
    // Verifica se jQuery está carregado antes de prosseguir
    if (typeof jQuery == 'undefined') {
        console.error('jQuery não está carregado. Slick Carousel requer jQuery.');
        return; // Aborta se jQuery não estiver presente
    }

    const abas = document.querySelectorAll('.categorias-destaque .abas-categorias li'); // Seletores mais específicos
    const carrosseis = document.querySelectorAll('.categorias-destaque .carrossel-container'); // Seletores mais específicos

    // Função para inicializar o carrossel Slick
    function initCarrossel(selector) {
        // Usa jQuery (indicado pelo $) para selecionar e inicializar o Slick
        jQuery(selector).slick({
            dots: true, // Exibe os pontos de navegação
            arrows: true, // Exibe as setas de navegação
            infinite: false, // Recomenda-se false se houver poucos produtos
            speed: 300,
            slidesToShow: 4, // Quantos produtos mostrar por vez (ajuste!)
            slidesToScroll: 1,
            responsive: [ // Configurações para diferentes tamanhos de tela
                {
                    breakpoint: 1024, // Abaixo de 1024px
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600, // Abaixo de 600px
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480, // Abaixo de 480px
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
                // Pode adicionar mais breakpoints
            ]
            // Adicione outras opções do Slick conforme necessário
            // Veja a documentação do Slick para mais opções
        });
    }

    abas.forEach(aba => {
        aba.addEventListener('click', function() {
            const categoria = this.dataset.categoria;
            const seletorCarrosselAtivo = `.categorias-destaque .carrossel-container[data-categoria="${categoria}"]`; // Seletor específico
            const carrosselAtivo = document.querySelector(seletorCarrosselAtivo);

            // Remover classe ativo de todas as abas
            abas.forEach(a => a.classList.remove('ativo'));
            this.classList.add('ativo');

            // Ocultar todos os carrosseis (importante para Slick recalcular se necessário)
            carrosseis.forEach(carrossel => {
                // Se existir uma instância Slick, pausar ou ajustar conforme necessário
                if (jQuery(carrossel).hasClass('slick-initialized')) {
                    // Opcional: pausar o carrossel que está sendo escondido
                    // jQuery(carrossel).slick('slickPause');
                }
                carrossel.style.display = 'none';
            });


            if (carrosselAtivo) {
                carrosselAtivo.style.display = 'block';

                // ---- INICIALIZAÇÃO DO SLICK ----
                // Verifica se o Slick já foi inicializado neste contêiner
                // O Slick adiciona a classe 'slick-initialized'
                if (!jQuery(carrosselAtivo).hasClass('slick-initialized')) {
                    // Se não foi inicializado, inicializa agora
                    initCarrossel(seletorCarrosselAtivo);
                } else {
                    // Se JÁ foi inicializado, pode ser necessário forçar um reposicionamento
                    // após o contêiner ficar visível novamente.
                    jQuery(carrosselAtivo).slick('setPosition');
                    // Se estava pausado, retome
                    // jQuery(carrosselAtivo).slick('slickPlay');
                }
                // ---- FIM DA INICIALIZAÇÃO ----
            }
        });
    });

    // Inicializar o carrossel da primeira aba (se existir)
    const primeiraAba = document.querySelector('.categorias-destaque .abas-categorias li:first-child');
    if (primeiraAba) {
        // Simula o clique para acionar a lógica acima, incluindo a inicialização do Slick
        primeiraAba.click();
    } else if (carrosseis.length > 0) {
        // Fallback: Se não houver abas, mas houver carrosséis, inicializar o primeiro
        const primeiroCarrossel = carrosseis[0];
        primeiroCarrossel.style.display = 'block';
        initCarrossel('.categorias-destaque .carrossel-container:first-child');
    }
});